<template>
  <div>
    <u-tokens :deployment="deployment" />
    <h2 class="my-2 error--text">{{ $t('danger zone') }}</h2>
    <v-btn class="error" @click="openDelete">{{ $t('delete') }}</v-btn>
    <v-dialog v-model="dialog" @click:outside="closeDelete" no-click-animation width="800">
      <v-card dense>
        <v-card-title>{{ $t('confirmation') }}</v-card-title>
        <v-card-text><v-text-field v-model="input" /></v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeDelete" text>{{ $t('close') }}</v-btn>
          <v-btn class="error" @click="deleteNs" :disabled="input !== deployment">{{ $t('delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Network from '@/services/network.ts'
import Tokens from '@/views/Tokens.vue'

export default {
  data() {
    return {
      input: '',
      dialog: false,
    }
  },
  props: {
    deployment: String
  },
  methods: {
    openDelete () {
      this.dialog = true
    },
    closeDelete () {
      this.dialog = false
    },
    deleteNs () {
      Network.deleteNamespace(this.deployment)
        .then(() => this.$router.push('/deployments'))
    }
  },
  components: {
    'u-tokens': Tokens
  }
}
</script>

<i18n>
{
  "en": {
    "close": "Close",
    "confirmation": "Please confirm you want to delete this deployment by typing its name below.",
    "danger zone": "Danger Zone",
    "delete": "Delete Deployment"
  }
}
</i18n>
